import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import Login from './Login';

const Landing = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ 
      display: 'flex', 
      height: '100vh',
      flexDirection: isMobile ? 'column' : 'row',
      bgcolor: 'background.default',
      overflow: 'hidden'
    }}>
      {/* Left side - Project Info */}
      <Box
        sx={{
          flex: isMobile ? '0 0 auto' : 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: isMobile ? '3vh' : '5vh',
          backgroundColor: 'background.paper',
          borderRight: isMobile ? 'none' : `1px solid ${theme.palette.divider}`,
          borderBottom: isMobile ? `1px solid ${theme.palette.divider}` : 'none',
          height: isMobile ? '25vh' : '100vh',
        }}
      >
        <Box sx={{ mb: '1vh' }}>
          <Typography 
            variant={isMobile ? "h4" : "h2"} 
            component="h1" 
            fontWeight="bold" 
            color="primary"
            sx={{ 
              fontSize: isMobile ? 'calc(1.5rem + 1vh)' : 'calc(2rem + 2vh)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 2
            }}
          >
            Writellect
            <Typography
              component="span"
              variant="caption"
              sx={{
                opacity: 0.7,
                bgcolor: 'action.selected',
                px: 2,
                py: 0.8,
                borderRadius: 1,
                userSelect: 'none',
                fontSize: '0.7rem',
                whiteSpace: 'nowrap'
              }}
            >
              Alpha v0.1
            </Typography>
          </Typography>
        </Box>
        <Typography 
          variant={isMobile ? "subtitle1" : "h5"} 
          color="text.primary"
          sx={{ 
            fontSize: isMobile ? 'calc(0.9rem + 0.5vh)' : 'calc(1rem + 1vh)',
            mb: '1vh'
          }}
        >
          AI-Powered Content Creation
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{
            fontSize: isMobile ? 'calc(0.8rem + 0.3vh)' : 'calc(0.9rem + 0.5vh)',
          }}
        >
          Transform your ideas into engaging content with the power of AI.
        </Typography>
        {!isMobile && (
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom color="text.primary">
              Key Features:
            </Typography>
            <Typography component="ul" sx={{ pl: 2 }} color="text.secondary">
              <li>AI-powered article generation</li>
              <li>Smart content planning</li>
              <li>Social media post creation</li>
              <li>Brand voice customization</li>
              <li>Image generation and management</li>
            </Typography>
          </Box>
        )}
      </Box>

      {/* Right side - Auth */}
      <Box
        sx={{
          flex: isMobile ? 1 : 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'background.default',
          height: isMobile ? '75vh' : '100vh',
          overflow: 'hidden',
          p: isMobile ? '2vh' : '3vh',
        }}
      >
        <Login />
      </Box>
    </Box>
  );
};

export default Landing; 